import { Amplify } from "aws-amplify";
import { createApp } from "vue";

import "@/assets/styles/premium-table.css";
import "@/assets/styles/premium-table-loading.css";
import "@/assets/styles/premium-dialog.css";
import "@/assets/styles/premium-action-menu.css";
import "@/assets/styles/premium-form-fields.css";
import "@/assets/styles/premium-module-page.css";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";

loadFonts();
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "ap-south-1_bu6ZJ4yoh",
      region: "ap-south-1",
      userPoolClientId: "ih0b738643b4u04cd17324212",
    },
  },
  API: {
    GraphQL: {
      endpoint:
        "https://325vprp5qba53dcxgwc3kkoybi.appsync-api.ap-south-1.amazonaws.com/graphql",
      region: "ap-south-1",
      defaultAuthMode: "userPool",
    },

    REST: {
      Report_issue: {
        endpoint:
          " https://61fvl4pi50.execute-api.ap-southeast-1.amazonaws.com/dev/",
      },
    },
  },
});

createApp(App).use(router).use(store).use(vuetify).mount("#app");
